import BioReviewPage from './BioReviewPage';

export default BioReviewPage;
